import { useState } from "react";
import DescriptionIcon from "@mui/icons-material/Description";
import { Spinner, Tooltip } from "@chakra-ui/react";

export const ResumeLoader = ({ SubmissionPreview, value, handleSubmissionPreviewShow,
  setId }) => {
  const [loading, setLoading] = useState(true);

  return (
    <>
      {loading ? (
        <>
          <Tooltip hasArrow label="Resume Preview" bg="gray.300" color="black">
            <DescriptionIcon
              className="list_view"
              onClick={() => {
                setLoading(false);
                handleSubmissionPreviewShow && handleSubmissionPreviewShow()
                setId && setId(value?.candidate_id || value?._id,)
                SubmissionPreview(
                  value?.candidate_id || value?._id,
                  value
                ).then((res) => {
                  setTimeout(() => {
                    setLoading(true);
                  }, 500);
                });
              }}
            />
          </Tooltip>{" "}
        </>
      ) : (
        <Spinner
          marginLeft={"10px"}
          marginRight={"5px"}
          color="#083c64"
          size="sm"
        />
      )}
    </>
  );
};
